import { JobStatus } from './enums.js';
export function normalizeJobStatus(status) {
    return String(status ?? '').trim().toUpperCase();
}
export function isCompletedJobStatus(status) {
    return normalizeJobStatus(status) === JobStatus.COMPLETED;
}
export function isInProgressJobStatus(status) {
    return normalizeJobStatus(status) === JobStatus.IN_PROGRESS;
}
export function isOpenJobStatus(status) {
    const normalized = normalizeJobStatus(status);
    return (normalized === JobStatus.DRAFT ||
        normalized === JobStatus.SCHEDULED ||
        normalized === JobStatus.IN_PROGRESS ||
        normalized === JobStatus.ON_HOLD ||
        normalized === 'PENDING');
}
/** Prisma `in` lists covering stored enum + legacy lowercase. */
export const COMPLETED_JOB_STATUS_FILTER = [JobStatus.COMPLETED, 'completed'];
export const IN_PROGRESS_OR_COMPLETED_JOB_STATUS_FILTER = [
    JobStatus.IN_PROGRESS,
    'in_progress',
    JobStatus.COMPLETED,
    'completed',
];
export const OPEN_JOB_STATUS_FILTER = [
    JobStatus.DRAFT,
    JobStatus.SCHEDULED,
    JobStatus.IN_PROGRESS,
    JobStatus.ON_HOLD,
    'pending',
    'scheduled',
    'in_progress',
];
//# sourceMappingURL=jobStatusFilters.js.map